/* global localStorage */
import { Component } from 'preact'
import { connect } from 'unistore/preact'

import Footer from '../../footer'
import AppSection from '../app-section'
import ResultHero from './hero-section'
import ShareSection from './share-section'
import s from './index.sass'
import { FullScreenLoader } from '../../loader'
import { LS } from '../constants'
import {
  setPrice,
  setInput,
  setAddOns,
  setSuggestion,
  getSignatureCases,
  getReceipt
} from './actions'
import { getSuggested } from '../selectors'
import prerendered from '../../../hoc/prerendered-content'
import { purchase } from '../../../helpers/analytics'
import { getUserId, getUsername } from '../../../login'
import { setNoIndex } from '../../../helpers/meta-tags'

class SignUpResult extends Component {
  state = {
    isLoading: true
  }

  componentDidMount () {
    setNoIndex()
    const showSignatureCases = false // Hiding signature cases per request from STC. See sc-26834.
    if (this.props.error) {
      this.setState({
        isLoading: false
      })
    } else {
      Promise.all([
        // showSignatureCases && this.props.getSignatureCases(),
        this.props.getReceipt(this.props.order),
        this.props.setInput(JSON.parse(localStorage.getItem(LS.input))),
        this.props.setSuggestion(JSON.parse(localStorage.getItem(LS.suggestion))),
        this.props.setAddOns(JSON.parse(localStorage.getItem(LS.addOns)))
      ])
        .then(() => {
          if (localStorage.getItem(LS.purchaseHash)) { // We only want to run this once, should the user reload the page for some reason.
            console.log('purchase has was', LS.purchaseHash)
            localStorage.removeItem(LS.purchaseHash)
            console.log('club', this.props.signUpInput.club)
            purchase(getUserId(), getUsername(), this.props.paymentReceipt, this.props.signUpInput.club)
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.setState({
            isLoading: false,
            showSignatureCases,
            shareUrl: localStorage.getItem(LS.shareUrl),
            email: localStorage.getItem(LS.email)
          })

          localStorage.removeItem(LS.shareUrl)
          localStorage.removeItem(LS.prices)
          localStorage.removeItem(LS.input)
          localStorage.removeItem(LS.addOns)
          localStorage.removeItem(LS.suggestion)
          localStorage.removeItem(LS.email)
        }
        )
    }
  }

  render ({
    signUpInput,
    signUpAddOns,
    suggestion,
    content,
    // stateSignatureCases,
    paymentReceipt,
    error,
    order
  }, {
    list,
    isLoading,
    shareUrl,
    email
    // showSignatureCases
  }) {
    // const isAssently = false // stateSignatureCases && !!stateSignatureCases.find(c => c.documentUrl.indexOf('assently') > -1)
    const { guideInputs, addOnsCopy } = content

    return (
      <div class={s.view}>
        {isLoading && !guideInputs
          ? <FullScreenLoader />
          : (
            <div class={s.signUpResult}>
              <ResultHero
                price={`${paymentReceipt.amountSEK}kr`}
                list={list}
                email={email}
                suggestion={suggestion}
                inputs={signUpInput}
                addOns={signUpAddOns}
                addOnsCopy={addOnsCopy}
                guideInputs={guideInputs}
                shareUrl={shareUrl}
                error={error}
              />

              <hr />

              {!error && <div>
                <ShareSection
                  title='Tipsa någon du vill träna med!'
                  description='Köp samma kort som du själv precis gjort med en länk.'
                  cardColor={suggestion && suggestion.cardColor}
                  cardText={suggestion && suggestion.title}
                  url={shareUrl}
                />

                <hr />
              </div>}

              <AppSection
                imageUrl='/images/stc-app.png'
                imageAlt='Mobiltelefoner som visar upp STCs app'
                title='Ladda ner vår app!'
                description='Boka din gruppträning i STC-appen och säkra din plats på något av våra 30, 45 eller 60 minuters träningspass på ett enkelt och snabbt sätt direkt i mobilen. Här hittar du också Online Training med våra egna pass och pass från Les Mills,  personliga gymprogram och massor av träningstips och övningar.'
                appStoreUrl='https://apps.apple.com/us/app/stc-training-club/id575468749'
                playStoreUrl='https://play.google.com/store/apps/details?id=se.stc.trainingclub'
              />

            </div>
          )
        }

        {/* {showSignatureCases && (
          <Modal title='Vi behöver en signatur, sen är du igång!' noClose centered noScroll fullscreen>
            <p>Gå in på nedanstående länk{stateSignatureCases.length > 1 ? 'ar' : ''} för att signera medlemsavtalet{paymentReceipt.paymentType === PAYMENT_METHODS.autogiro ? ' och autogiro' : ''}.</p>
            {isAssently && <p>Signering sker via <img src='/images/assently.svg' width={80} /></p>}
            {stateSignatureCases.map((signatureCase, i) => (
              <p class={i === 0 && 'accept-button'}><ActionButton href={signatureCase.documentUrl} target='_blank' label={i === 0 ? 'Signera här' : 'Och här'} /></p>
            ))}
            <p><a onClick={_ => this.setState({ showSignatureCases: false })}>Jag har signerat</a></p>
          </Modal>
        )} */}

        <Footer />
      </div>
    )
  }
}

export const selectors = (state) => {
  const { signUpInput, signUpAddOns, signatureCases, paymentReceipt } = state
  return {
    signUpInput,
    signUpAddOns,
    stateSignatureCases: signatureCases,
    paymentReceipt,
    suggestion: getSuggested(state)
  }
}

export default prerendered(connect(selectors, { setPrice, setInput, setAddOns, setSuggestion, getSignatureCases, getReceipt })(SignUpResult))



// WEBPACK FOOTER //
// ./components/signup-flow/step-result/index.js